
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Missing Declarations for `}<inlineCode parentName="h2">{`styled-components/native`}</inlineCode>{`?`}</h2>
    <p>{`If you're getting the error message:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`Could not find a declaration file for module 'styled-components/native'
`}</code></pre>
    <p>{`In a React Native project using TypeScript, it is because you need to add `}<inlineCode parentName="p">{`@types/styled-components-react-native`}</inlineCode>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;